import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { withToggle } from "../../../../enhancers";
import FixedOverlay from "../FixedOverlay";
import styles from "./styles.pcss";
import Icon from "../../../Icon";
import { getMobileOS } from "../../../../utils/detect-mobile";
var isMobile = getMobileOS() === 'android' || getMobileOS() === 'ios';
var cx = classNames.bind(styles);

/**
 * Stateless popup layout with screen overlay
 * Appears by sliding down from top of the screen,
 * Content has predefined size and fixed outer indents, but no padding
 */
export var BasePopupStateless = function BasePopupStateless(_ref) {
  var children = _ref.children,
    isOpen = _ref.isOpen,
    isWide = _ref.isWide,
    onClose = _ref.onClose,
    className = _ref.className,
    hideCloseButton = _ref.hideCloseButton,
    hasScrollOverlay = _ref.hasScrollOverlay;
  return /*#__PURE__*/React.createElement(FixedOverlay, {
    className: cx('overlay'),
    hasScrollOverlay: hasScrollOverlay,
    isOpen: isOpen,
    onClose: onClose,
    "data-t-id": "components-BasePopup"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('component', className, {
      isWide: isWide
    }),
    "data-t-id": "components-BasePopup"
  }, /*#__PURE__*/React.createElement("button", {
    className: cx('cross', 'popupCloseButton', {
      hideCloseButton: hideCloseButton
    }),
    onClick: onClose,
    type: "button"
  }, isMobile ? /*#__PURE__*/React.createElement(Icon, {
    name: "closeMobile"
  }) : /*#__PURE__*/React.createElement(Icon, {
    name: "closeDesktop"
  })), children));
};
BasePopupStateless.propTypes = process.env.NODE_ENV !== "production" ? {
  isOpen: PropTypes.bool,
  isWide: PropTypes.bool,
  hasScrollOverlay: PropTypes.bool,
  hideCloseButton: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
} : {};

/**
 * One-use popup, initially open, it can only be closed once and for good
 * For all other use cases, please refer to Stateless version
 */
export var BasePopupDisposable = withToggle(BasePopupStateless);
BasePopupDisposable.defaultProps = {
  isOpen: true
};